var map = {
	"./img_1.jpg": 79031,
	"./img_2.jpg": 41976,
	"./img_3.jpg": 74985,
	"./img_4.jpg": 91167,
	"./img_5.jpg": 2553,
	"./img_6.jpg": 12728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5161;